import { p as proxyCustomElement, H, f as forceUpdate, h } from './p-ae815584.js';
import { n as nextTick, s as slotMutationService, b as bem } from './p-c44c2366.js';
import { F as FormField } from './p-8e5cca04.js';
import { c as getAriaDisabled, g as getAriaInvalid, a as getAriaDescribedBy, b as getAriaRequired } from './p-55335119.js';
import { d as defineCustomElement$3 } from './p-71f91db6.js';
import { d as defineCustomElement$2 } from './p-db87170c.js';
import { t as transformTagName, r as resolveAppearance } from './p-c01ca34a.js';

const cosmosRadioGroupCss = ".cosmos-form-field{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.cosmos-form-field__info-container{display:inline-block;margin-bottom:8px}.cosmos-form-field__info-container:not(.cosmos-form-field__info-container--has-label,.cosmos-form-field__info-container--has-help-text,.cosmos-form-field__info-container--has-required-optional-label){display:none}.cosmos-form-field__label-text,.cosmos-form-field__help-text,.cosmos-form-field__required-optional-label,.cosmos-form-field__validation-message{display:inline}.cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color);--cosmos-text-font-family:var(--cosmos-radio-group-label-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-label-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-label-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-label-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-label-text-transform)}.cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color);--cosmos-text-font-family:var(--cosmos-radio-group-help-text-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-help-text-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-help-text-text-transform)}.cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-radio-group-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-required-optional-label-text-transform);display:inline-block;-webkit-margin-start:4px;margin-inline-start:4px;white-space:nowrap}.cosmos-form-field__validation-message{display:-ms-flexbox;display:flex;gap:4px;margin-top:8px}.cosmos-form-field__validation-message-text{--cosmos-text-font-family:var(--cosmos-radio-group-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-radio-group-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-radio-group-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-radio-group-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-radio-group-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-radio-group-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-radio-group-validation-message-text-transform)}.cosmos-form-field__validation-message-icon{--cosmos-icon-color:var(--cosmos-radio-group-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));-ms-flex-negative:0;flex-shrink:0;padding:1.5px 0}.cosmos-form-field--invalid .cosmos-form-field__label-text,.cosmos-form-field--invalid .cosmos-form-field__validation-message{--cosmos-text-color:var(--cosmos-radio-group-label-color)}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-radio-group-label-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-radio-group-help-text-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-radio-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-radio-group__list{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:12px}";
const CosmosRadioGroupStyle0 = cosmosRadioGroupCss;

const generateClassNames = bem('cosmos-radio-group');
const radioTag = transformTagName('cosmos-radio');
const CosmosRadioGroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosRadioGroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.enabledRadios = [];
        this.isNavigatedWithKeyboard = false;
        this.radios = [];
        this.getValidationMessage = () => {
            if (this.validationMessage) {
                // Return custom validation message when set
                return this.validationMessage;
            }
            else {
                // Fallback to native validation message in uncontrolled setting
                if (!this.invalid && this.groupInvalid && this.enabledRadios.length) {
                    const radio = this.enabledRadios[0].shadowRoot.querySelector('input[type="radio"]');
                    return radio.validationMessage;
                }
            }
        };
        this.reannounceValidationMessage = async () => {
            if (this.validationMessageRef) {
                // Reset validation message to trigger re-announcement of the live region by screen readers
                // The aria-label is updated instead of the text content to avoid a visual flash
                this.validationMessageRef.ariaLabel = '';
                await nextTick();
                this.validationMessageRef.ariaLabel = this.getValidationMessage();
            }
        };
        this.handleSlotChange = () => {
            this.initializeRadios();
            forceUpdate(this); // Force re-render to update the help text aria-label if the slot content changes
        };
        this.appearance = undefined;
        this.disabled = undefined;
        this.helpText = undefined;
        this.invalid = false;
        this.label = undefined;
        this.optionalLabel = undefined;
        this.requiredLabel = undefined;
        this.validationMessage = undefined;
        this.computedAppearance = 'dark';
        this.groupInvalid = false;
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
        this.updateRadiosAppearance();
    }
    handleInvalidChange(newValue) {
        this.groupInvalid = newValue;
        this.updateRadiosInvalidState();
    }
    handleDisabledChange(newValue) {
        if (typeof this.disabled != 'undefined') {
            this.radios.forEach((radio) => {
                radio.disabled = newValue;
            });
        }
    }
    async handleInputchange(event) {
        const targetIndex = this.enabledRadios.findIndex((item) => item === event.target);
        await this.updateRadios(targetIndex);
        this.isInvalidStateControlled();
    }
    handleInputInvalid() {
        this.groupInvalid = true;
        this.updateRadiosInvalidState();
        this.reannounceValidationMessage();
    }
    async handleKeyDown(event) {
        this.isNavigatedWithKeyboard = event.key !== 'Tab';
        if (['ArrowUp', 'ArrowLeft', 'ArrowRight', 'ArrowDown'].includes(event.key)) {
            [this.radios, this.enabledRadios] = this.getRadios();
            // Prevent default browser action and arrow key scrolling
            event.preventDefault();
            let index = this.enabledRadios.findIndex((radio) => radio.checked);
            // Set index to 0 if none of the Radios are selected
            if (index == -1) {
                index = 0;
            }
            if (['ArrowUp', 'ArrowLeft'].includes(event.key)) {
                index--;
                if (index < 0) {
                    index = this.enabledRadios.length - 1;
                }
            }
            else {
                index++;
                if (index >= this.enabledRadios.length) {
                    index = 0;
                }
            }
            await this.updateRadios(index);
        }
    }
    // Will not update children to valid if invalid state is controlled
    isInvalidStateControlled() {
        if (!this.invalid) {
            this.groupInvalid = false;
            this.updateRadiosInvalidState();
        }
    }
    getRadios() {
        const allRadios = [...this.element.querySelectorAll(radioTag)];
        const enabledRadios = allRadios.filter((item) => !item.disabled);
        return [allRadios, enabledRadios];
    }
    updateRadiosAppearance() {
        this.radios.forEach((radio) => {
            radio.appearance = this.computedAppearance;
        });
    }
    async updateRadios(targetIndex) {
        if (!this.enabledRadios.length) {
            return;
        }
        this.enabledRadios.forEach((radio, radioIndex) => {
            if (targetIndex !== radioIndex) {
                radio.checked = false;
            }
            radio.invalid = this.groupInvalid;
            radio.focusable = false;
        });
        if (typeof targetIndex !== 'undefined' && targetIndex !== -1 && this.enabledRadios[targetIndex]) {
            const targetRadio = this.enabledRadios[targetIndex];
            targetRadio.checked = true;
            targetRadio.focusable = true;
            if (this.isNavigatedWithKeyboard) {
                await targetRadio.inputFocus();
            }
        }
        else {
            this.enabledRadios[0].focusable = true;
        }
    }
    updateRadiosInvalidState() {
        this.radios.forEach((radio) => {
            radio.invalid = this.groupInvalid;
        });
    }
    updateRadiosDisabledState() {
        if (typeof this.disabled != 'undefined') {
            this.radios.forEach((radio) => {
                radio.disabled = this.disabled;
            });
        }
    }
    initializeRadios() {
        [this.radios, this.enabledRadios] = this.getRadios();
        this.updateRadiosDisabledState();
        this.updateRadiosInvalidState();
        this.updateRadiosAppearance();
        const preselectedRadio = this.enabledRadios.findIndex((radio) => radio.checked);
        this.updateRadios(preselectedRadio);
    }
    componentWillLoad() {
        this.groupInvalid = this.invalid;
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
        slotMutationService.observe(this.element, this.handleSlotChange);
    }
    disconnectedCallback() {
        slotMutationService.unobserve(this.element);
    }
    render() {
        return (h(FormField, { key: 'ad8d44633f13d63e29ac80edf355ac4226807f75', element: this.element, appearance: this.computedAppearance, class: generateClassNames(), helpText: this.helpText, invalid: this.groupInvalid, label: this.label, optionalLabel: this.optionalLabel, requiredLabel: this.requiredLabel, validationMessage: this.getValidationMessage(), validationMessageRef: (el) => (this.validationMessageRef = el), disabled: this.disabled, required: !!this.requiredLabel }, h("div", { key: 'bfc5abdee59b99b917e2fbd2318e813c418be9a3', "aria-disabled": getAriaDisabled(this.disabled), "aria-invalid": getAriaInvalid(this.groupInvalid), "aria-labelledby": `label ${getAriaDescribedBy(this.groupInvalid)}`, "aria-required": getAriaRequired(!!this.requiredLabel), class: generateClassNames('list'), role: "radiogroup" }, h("slot", { key: 'c1cb31a2bc3dd354658b0bb859e9898abe1aaa98' }))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"],
        "invalid": ["handleInvalidChange"],
        "disabled": ["handleDisabledChange"]
    }; }
    static get style() { return CosmosRadioGroupStyle0; }
}, [1, "cosmos-radio-group", {
        "appearance": [513],
        "disabled": [516],
        "helpText": [513, "help-text"],
        "invalid": [516],
        "label": [513],
        "optionalLabel": [513, "optional-label"],
        "requiredLabel": [513, "required-label"],
        "validationMessage": [513, "validation-message"],
        "computedAppearance": [32],
        "groupInvalid": [32]
    }, [[0, "inputchange", "handleInputchange"], [0, "inputinvalid", "handleInputInvalid"], [0, "keydown", "handleKeyDown"]], {
        "appearance": ["handleAppearanceChange"],
        "invalid": ["handleInvalidChange"],
        "disabled": ["handleDisabledChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-radio-group", "cosmos-icon-warning", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-radio-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosRadioGroup$1);
            }
            break;
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosRadioGroup = CosmosRadioGroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosRadioGroup, defineCustomElement };
